import React from 'react'
import Section from './Section'
import styles from './styles.module.css'

function CenteredTwoSidedContent(props) {
  const { content } = props

  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        {content.map((section, index) => {
          return <Section data={section} key={section._key} />
        })}
      </div>
    </div>
  )
}

export default CenteredTwoSidedContent
